@use "../../styles/breakpoint.module.scss" as *;

.block {
    --base-color-contrast: var(--color-contrast);
}

.root {
    composes: safeContainer from "../../styles/composable/layout.module.css";
    position: relative;
}

.hasUrl {
    cursor: pointer;
}

// Override Carousel's slidesWrapper to a grid so .slide and .card can subgrid
// its row tracks for cross-card alignment.
.slidesWrapper {
    --slides-visible: var(--slides-visible-desktop);
    --gap: var(--spacer-8);
    --slide-width: calc(
        (100% - (var(--slides-visible) - 1) * var(--gap)) /
            var(--slides-visible)
    );

    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: var(--slide-width);
    grid-template-rows: auto auto auto repeat(
            var(--compare-facet-count, 0),
            auto
        );
    justify-content: safe center;
    column-gap: var(--gap);

    @media ($below-tablet) {
        --slides-visible: var(--slides-visible-tablet);
    }

    @media ($below-mobile) {
        --slides-visible: var(--slides-visible-mobile);
    }
}

/* Subgrid chain: slidesWrapper > slide > card all share the same row tracks
 * so facet rows align across cards. */
.slide {
    display: grid;
    grid-template-rows: subgrid;
    grid-row: 1 / -1;
}

.card {
    display: grid;
    grid-template-rows: subgrid;
    grid-row: 1 / -1;
    padding-bottom: var(--spacer-16);
}

.cardActive {
    composes: card;
    box-shadow: 0 0 10px 0 rgb(from var(--base-color-contrast) r g b / 8%);

    .picture {
        background-color: var(--off-white);
    }
}

.header {
    display: grid;
    grid-template-columns: 1fr auto;
    grid-template-rows: auto 1fr;
    align-items: start;
    gap: var(--spacer-4);
    padding: var(--spacer-16);
}

.sku {
    grid-column: 1;
    color: var(--color-contrast-subtle);
    font: var(--font-eyebrow-12);
    letter-spacing: 0.1em;
    text-transform: uppercase;
}

.title {
    grid-column: 1;
    font: var(--font-p-18);
}

.badgePosition {
    grid-column: 1;
    justify-self: start;
}

.favoriteButton {
    grid-column: 2;
    grid-row: 1 / span 2;
    padding: var(--spacer-16);
    translate: var(--spacer-16) calc(var(--spacer-16) * -1);
}

.favoriteSvg {
    width: 16px;
    height: 16px;
    fill: currentColor;
}

.favoriteButton:not([data-is-favorite]):hover .favoriteSvg {
    --heart-fill: 75%;
}

.picture {
    display: block;
    background-color: var(--gray-100);
    aspect-ratio: 16 / 9;

    @media ($below-mobile) {
        aspect-ratio: 4 / 3;
    }
}

.image {
    display: block;
    width: 100%;
    height: 100%;
    aspect-ratio: 1;
    object-fit: contain;
}

.price {
    padding: 0 var(--spacer-16) var(--spacer-16);
    color: var(--color-contrast-subtle);
    font: var(--font-button-16);
}

/* <dl> disappears from layout so each .facetItem becomes a direct grid item
 * of .slide, occupying its own row of the subgrid for cross-card alignment. */
.facetList {
    composes: listReset from "../../styles/composable/utility.module.css";
    display: contents;
}

.facetItem {
    margin-inline: var(--spacer-16);
    border-top: 1px solid var(--gray-300);
    color: var(--color-contrast-muted);
}

.facetLabel {
    padding-block: var(--spacer-8);
    font: var(--font-eyebrow-12);
    letter-spacing: 0.1em;
    text-transform: uppercase;
}

.facetValue {
    padding-bottom: var(--spacer-8);
    font: var(--font-p-16);
}

.dots {
    position: static;
    justify-content: center;
    transform: none;
}
